export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const OPEN_CREATE_FORM = 'OPEN_CREATE_FORM';
export const CLOSE_CREATE_FORM = 'CLOSE_CREATE_FORM';
export const SET_EDITING_INDEX = 'SET_EDITING_INDEX';
export const CLOSE_EDIT_FORM = 'CLOSE_EDIT_FORM';
